<template>
  <div>   
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'Content',
    data() {
      return {
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-data-table-header th.resGrey-background {
    background-color: var(--v-resGrey-lighten3) !important;
  }
</style>
